import * as React from 'react';
import { Redo } from '@core-ds/icons/16';
import { TiptapButton } from '../TiptapButton';
import { Editor } from '@tiptap/react';

export const RedoButton = (props: { editor: Editor }) => {
   const editor: Editor = props.editor;

   return (
      <TiptapButton
         onClick={() => editor.chain().focus().redo().run()}
         isDisabled={!editor.can().redo()}
         icon={<Redo />}
         title={_js('Redo')}
         shortcut={'y'}
      ></TiptapButton>
   );
};
